<shared-navigation-main-desktop *ngIf="isDesktop"></shared-navigation-main-desktop>
<shared-navigation-main-mobile *ngIf="!isDesktop"></shared-navigation-main-mobile>